const duplicateTranslationKey = (key: string): string => key;

export const translationUploadData_en_part4 = {
  errorFetchingOrganizations: "Error fetching organizations",
  // Folder management translations
  // Folder management translations
  createFolder: "Create Folder",
  createNewFolder: "Create New Folder",
  folderName: "Folder Name",
  enterFolderName: "Enter folder name",
  parentFolder: "Parent Folder",
  selectParentFolder: "Select parent folder",
  rootNoFolder: "Root (No Folder)",
  uploadToFolder: "Upload to Folder",
  selectFolder: "Select folder",
  folderNameRequired: "Folder name is required",
  folderCreatedSuccessfully: "Folder created successfully",
  errorCreatingFolder: "Error creating folder",
  creatingFolder: "Creating...",
  uploadToThisFolder: "Upload to this folder",
  entryMovedToFolder: "Entry moved to folder",
  entryMovedToRoot: "Entry moved to root",
  errorMovingEntryToFolder: "Failed to move entry to folder",
  dragToMove: "Drag to move",
  noIndexesAvailable: "No knowledge bases available",
  retry: "Retry",
  numberOfChunks: "Number of chunks",
  renameFolder: "Rename Folder",
  renameFolderButton: "Rename",
  renamingFolder: "Renaming...",
  folderRenamedSuccessfully: "Folder renamed successfully",
  errorRenamingFolder: "Failed to rename folder",
  changesSavedSuccessfully: "Changes saved successfully",
  allInformationChunksLoaded: "All information chunks loaded",
  // PDF Chunking translations
  // PDF Chunking translations
  smartChunking: "Smart Chunking",
  smartChunkingTooltip:
    "Delar automatiskt upp PDF i meningsfulla delar baserat på titlar, stycken och innehållsstruktur. Rekommenderas för bättre söknoggrannhet.",
  pdfChunkingResults: "PDF Chunking Results",
  textChunkingResults: "Text Chunking Results",
  totalChunks: "Antal Delar",
  avgSize: "Snitt Storlek",
  range: "Intervall",
  chars: "tecken",
  chunkUploadNote: "Varje del kommer att laddas upp som en separat, sökbar post",
  // PDF Upload translations
  // PDF Upload translations
  uploadPdfLabel: "Upload PDF (optional)",
  uploadPdfButton: "Upload PDF",
  extractingText: "Extracting text...",
  uploadPdfDescription: "Upload a PDF file to automatically extract and populate the text below",
  pdfLoaded: "Loaded",
  verifyFileType: "File type is not valid. Please select a PDF file.",
  [duplicateTranslationKey("immediateUpload")]: "Immediate Upload",
  [duplicateTranslationKey("scheduleUpload")]: "Schedule Upload",
  itemCreatedOn: "Created {date}",
  itemEditedOn: "Edited {date}",
  viewHistory: "View history",
};
